<p-confirmDialog></p-confirmDialog>

<div class="flex flex-column w-full h-full align-content-between">
  <!-- Toolbar -->
  <div class="flex mb-4 gap-2 w-full align-items-center justify-content-end">
    <!-- Bouton d'import Excel -->
    <p-fileUpload
      choiceIcon="pi pi-download"
      mode="basic"
      (onSelect)="onUpload($event)"
      [multiple]="false"
      class="custom-file-upload"
      accept=".xlsx,.xls"
      maxFileSize="5000000"
      chooseLabel="Charger titres">
    </p-fileUpload>
  </div>

  <!-- Formulaire de recherche -->
  <p-card class="mb-4">
    <ng-template pTemplate="header">
      <div class="px-3 pt-3">
        <h3 class="m-0">Recherche de titres</h3>
      </div>
    </ng-template>

    <form [formGroup]="searchForm" class="flex align-items-end gap-3">
      <!-- Région (Pays) -->
      <div class="flex-1">
        <label for="region" class="block mb-2">Région (Pays)</label>
        <p-select
          id="region"
          formControlName="region"
          [options]="countries"
          optionLabel="name"
          optionValue="code"
          placeholder="Sélectionner un pays"
          [filter]="true"
          [showClear]="true"
          styleClass="w-full">
          <ng-template let-country pTemplate="selectedItem">
            <div class="flex align-items-center gap-2" *ngIf="country">
              <img [src]="country.flagUrl" style="width: 20px" [alt]="country.name" />
              <span>{{ country.name }}</span>
            </div>
          </ng-template>
          <ng-template let-country pTemplate="item">
            <div class="flex align-items-center gap-2">
              <img [src]="country.flagUrl" style="width: 20px" [alt]="country.name" />
              <span>{{ country.name }}</span>
            </div>
          </ng-template>
        </p-select>
      </div>

      <!-- Période (Date d'opération) -->
      <div class="flex-1">
        <label class="block mb-2">Période (Date d'opération)</label>
        <date-range
          [minDate]="minDate"
          [rangeDates]="rangeDates"
          (dateRangeSelected)="onDateRangeSelected($event)"
          (invalidRange)="onInvalidRange($event)" />
      </div>

      <!-- Type d'instrument -->
      <div class="flex-1">
        <label for="typeInstrument" class="block mb-2">Type d'instrument</label>
        <p-select
          id="typeInstrument"
          formControlName="typeInstrument"
          [options]="typeInstrumentOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Sélectionner le type"
          [showClear]="true"
          styleClass="w-full">
        </p-select>
      </div>

      <!-- Boutons d'action -->
      <div class="flex gap-2">
        <p-button
          icon="pi pi-refresh"
          severity="secondary"
          [rounded]="true"
          pTooltip="Réinitialiser"
          tooltipPosition="top"
          (onClick)="onReset()">
        </p-button>
        <p-button
          icon="pi pi-search"
          severity="primary"
          [rounded]="true"
          pTooltip="Rechercher"
          tooltipPosition="top"
          (onClick)="searchTitres()">
        </p-button>
      </div>
    </form>
  </p-card>

  <!-- Tableau des résultats -->
  <div class="">
    <dynamic-table
      [headers]="columns"
      [data]="titres"
      [pageParams]="pageable"
      [actions]="actions"
      (paginate)="onPageChange($event)">
    </dynamic-table>
  </div>
</div>
